import { api } from '../api';

const unwrap = (r) => r.data?.data ?? r.data;

export default {
  /* ── loan car fleet ── */
  list:   (params)   => api.get('/v1/loan-cars', { params }).then(unwrap),
  get:    (id)       => api.get(`/v1/loan-cars/${id}`).then(unwrap),
  create: (body)     => api.post('/v1/loan-cars', body).then(unwrap),
  update: (id, body) => api.patch(`/v1/loan-cars/${id}`, body).then(unwrap),
  remove: (id)       => api.delete(`/v1/loan-cars/${id}`).then(unwrap),

  /* ── loan agreements ── */
  agreements:      (params)   => api.get('/v1/loan-agreements', { params }).then(unwrap),
  createAgreement: (body)     => api.post('/v1/loan-agreements', body).then(unwrap),
  returnAgreement: (id, body) => api.post(`/v1/loan-agreements/${id}/return`, body).then(unwrap), // {kmIn, fuelIn, conditionInNotes}
};
